module.exports = __webpack_public_path__ + "static/media/uniprid_8g.cda2ad0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/climasense/barrenador_nogal/curativa/uniprid_8g.png
// module id = 1900
// module chunks = 3